import React from "react";

const EditCampaign = () => {

    return (

        <div className="marketing-page">

            <h2>Edit Campaign</h2>

            <p>
                This page will load the selected campaign,
                populate the form,
                and update it using the API.
            </p>

        </div>

    );

};

export default EditCampaign;